document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-page-close]');
  if (!closeButton || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  let referrer;
  try {
    referrer = document.referrer ? new URL(document.referrer) : null;
  } catch (error) {
    referrer = null;
  }

  const hasStorefrontReferrer = referrer?.origin === window.location.origin && referrer.pathname !== window.location.pathname;
  if (!hasStorefrontReferrer) return;

  event.preventDefault();
  window.history.back();
});
